import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'servicestack/notes/entity-note-prompt.htm'
import config from 'emun.customer/customer.config'
import VideoMessagePrompt from 'servicestack/video-message/video-message-prompt.es6'
import "servicestack/notes/entity-note-prompt.scss";

function EntityNotePromptController($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = new ServiceBus($rootScope);
    $ctrl.title = 'Enter Note...';
    $ctrl.config = config;
	if (options.title) {
		$ctrl.title = options.title;
	}

    $ctrl.loadNotes = function() {
        const $ctrl = this;
        $ctrl.bus.read("QueryEntityNotes.json", {
            orderBy: 'CreatedOn',
            tagCriteria: {
                    "EntityId": $ctrl.model.entityId,
                    "EntityType": $ctrl.model.entityType
            }
        }).then((res) => {
            $ctrl.notes = res.data.results;

        });
    }

    $ctrl.save = $ctrl.submit = function () {
            bus.send('CreateEntityNote.json', $ctrl.model.note).then(function (response) {
                $rootScope.$emit('entityNoteSaved', $ctrl);
                $ctrl.model.note.noteText = "";
                $ctrl.loadNotes();
            });
        //}
    };
    $ctrl.delete = function() {
        $uibModalInstance.close($ctrl.model);
        return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
            $ctrl.bus.send('DeleteEntityNote.json', $ctrl.model.note).then(function (response) {
                $rootScope.$emit('entityNoteDeleted', $ctrl);
            });
        });
    }
    $ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
    };
    $ctrl.upload = function($files) {    
        const $ctrl = this;
        if ($files && $files.length) {
          const req = {
            request: {
                realm: "Notes",
                tags: {
                    "EntityId": $ctrl.model.entityId,
                    "EntityType": $ctrl.model.entityType
                }
            },
            files: $files,
            urls: []
        };
    
          $ctrl.bus.upload('CreateMedia.json', req).then(
            res => {
                if (res.data.media.length) {
                    $ctrl.model.note.noteText = res.data.media[0].contentType;
                    $ctrl.model.note.refId = res.data.media[0].url;
                    bus.send('CreateEntityNote.json', $ctrl.model.note).then(function (response) {
                        $rootScope.$emit('entityNoteSaved', $ctrl);
                        $ctrl.model.note.noteText = "";
                        $ctrl.loadNotes();
                    });
                }
            }, res => modals.alert(JSON.stringify(res),'Could not save media!'));
        }
    }

    $ctrl.openVideoMessage = function() {
        const $ctrl = this;
        VideoMessagePrompt.open({model: $ctrl.model}).then(function(res) {
            console.debug("BL*** videomessageprompt ret ", res);
            $ctrl.model.note.noteText = res.contentType;
            $ctrl.model.note.refId = res.url;
            bus.send('CreateEntityNote.json', $ctrl.model.note).then(function (response) {
                $rootScope.$emit('entityNoteSaved', $ctrl);
                $ctrl.model.note.noteText = "";
                $ctrl.loadNotes();
            });
        });
    }

    $ctrl.loadNotes();

    $rootScope.$on('videoRecordingSaved', (e,args) => {
        $ctrl.upload(args);
    });
}

const EntityNotePrompt =  {
    open(options) {
        return modals.open(angular.extend({
            size: 'md',
            templateUrl: templateUrl,
            resolve: {
                options: () => options
            },
            controller: EntityNotePromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};


export default EntityNotePrompt;